import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyledIcon } from './styles'

export default function IsToodoPayBadge() {
  const { t } = useTranslation()
  return (
    <StyledIcon
      title={t('web.resources.payment-resources.toodopay')}
      type="credit-card"
      color="skyblue"
    />
  )
}
